export default __webpack_public_path__ + "static/logo-386adc327a6768c735ed73f604cbc11d.png";